import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FuseConfirmationModule } from './services/confirmation';
import { FuseSplashScreenModule } from './services/splash-screen/splash-screen.module';
import { FuseTailwindConfigModule } from './services/tailwind/tailwind.module';
import { FuseUtilsModule } from './services/utils/utils.module';

@NgModule({
    imports: [
        CommonModule,
        FuseSplashScreenModule,
        FuseTailwindConfigModule,
        FuseConfirmationModule,
        FuseUtilsModule
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill'
            }
        }]
})
export class FuseModule {
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: FuseModule) {
        if (parentModule) {
            throw new Error('FuseModule has already been loaded. Import this module in the AppModule only!');
        }
    }
}
